export default __webpack_public_path__ + "static/media/distributor-banner-bg.6c47dc17.jpg";